export const Settings = 'components/Settings';

export const Settingsi18n = {
  en: {
    profileSettings: {
      title: 'Profile',
      userDetails: 'User details',
      fullName: 'Full name',
      email: 'Email',
    },
    generalSettings: {
      settings: 'Settings',
      generalInformation: 'General information',
      bargeName: 'Barge name',
      bargeIMO: 'Barge IMO',
      bargeRegionalID: 'Regional ID Number (i.e. SB Number)',
      bargeMMSI: 'Barge MMSI',
      systemConfiguration: 'System configuration',
      adminWarning: 'These are ADMIN ONLY settings',
      edgeCredentials: 'Edge credentials',
      webAppVersion: 'Web app version',
      currentVersion: 'Current version: {{version}}',
      selectBarge: 'Select a barge to proceed with settings',
      searchBarge: 'Search for an option',
      selectedBarge: 'Barge: {{barge}}',
      done: 'Save changes',
    }
  },
}; 